export default __webpack_public_path__ + "static/media/510.1ce1a1c5.png";